import React from "react";
import { contractBadge } from "./adminUtils";

export const ContractBadge = ({ iso, className = "" }) => {
  const b = contractBadge(iso);
  if (!b) return null;
  return (
    <span className={`text-[9px] font-bold uppercase px-1.5 py-0.5 rounded-full ${b.cls} ${className}`}>{b.label}</span>
  );
};
